<template>
  <fieldset
    :class="['p2a-fieldset-' + type, {'p2a-requires-input': required,
                                      'p2a-input-error': hasError}]"
  >
    <label
      :for="'input-' + name"
      class="p2a-input-label"
    >
      <span v-if="label">{{ label }}</span>
      <input
        v-if="type !== 'textarea'"
        :aria-label="label"
        :id="'input-' + name"
        :name="name"
        :value="value"
        :autocomplete="autocomplete"
        :type="type"
        :maxlength="maxlength"
        :pattern="pattern"
        :placeholder="placeholder"
        v-on="$listeners"
      >
      <textarea
        v-if="type === 'textarea'"
        :aria-label="label"
        :id="'input-' + name"
        :name="name"
        :value="value"
        :autocomplete="autocomplete"
        :type="type"
        :maxlength="maxlength"
        :pattern="pattern"
        :placeholder="placeholder"
        rows="6"
        v-on="$listeners"
      />
    </label>
    <span
      v-show="error && error.length"
      class="p2a-error-message"
      v-html="error"
    />
  </fieldset>
</template>
<script>
export default {
  name: "FieldText",
  props: {
    autocomplete: {
      type: String,
      default: ""
    },
    error: {
      type: [String, Boolean],
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    label: {
      default: "",
      type: String
    },
    maxlength: {
      type: String,
      default: ""
    },
    name: {
      required: true,
      type: String
    },
    pattern: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "text"
    },
    value: {
      type: String,
      default: ""
    },
    validateable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasError() {
      return this.validateable && !!this.error;
    },
    isValid() {
      return this.validateable && !this.hasError && this.value.length > 0;
    }
  }
};
</script>
